const deleteQuicksight = {
  toastr: 'Usuario eliminado',
  toastr1: ' eliminado con éxito'
};

export default deleteQuicksight;
